import { Component } from 'react'
import { connect } from 'react-redux'
import Guide from 'components/Guide'
import { RelatedContentContainer } from 'containers'
import { fetchGuide } from './actions'
import { selectGuide, selectGuideFetching } from './selectors'
import { updateTitle } from '../Breadcrumbs/actions'
import { createEvent } from '../UserEvents/actions'

class GuideContainer extends Component {
  state = {
    level: 0,
    currentStep: {}
  }

  componentDidMount() {
    this.props.fetchGuide(
      this.props.location.query.device,
      this.props.params.id
    )
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.guide.children) {
      this.setState({ currentStep: nextProps.guide.children[0] })
    }
    if (this.props.params.id !== nextProps.params.id) {
      this.props.fetchGuide(
        nextProps.location.query.device,
        nextProps.params.id
      )
    }

    if (this.props.guide !== nextProps.guide) {
      this.props.updateTitle(nextProps.guide.text)

      this.props.createEvent({
        category: 'guides',
        data: { action: 'GuideSelect', target: nextProps.guide.val }
      })
    }
  }

  findByLevel = (level, obj) => {
    if (level !== 0) {
      return this.findByLevel(level - 1, obj.children[0])
    }
    return obj.children[0]
  }

  next = () => {
    const nextStep = this.state.currentStep.children[0]
    if (nextStep) {
      const nextLevel = this.state.level + 1
      const step = this.findByLevel(nextLevel, this.props.guide)
      this.setState({
        level: nextLevel,
        currentStep: step,
        isLastStep: step.children.length === 0
      })
    }
  }

  back = () => {
    if (this.state.level > 0) {
      const prevLevel = this.state.level - 1
      const step = this.findByLevel(prevLevel, this.props.guide)
      this.setState({ level: prevLevel, currentStep: step, isLastStep: false })
    }
  }

  render() {
    return (
      <div>
        <Guide
          guide={this.props.guide}
          step={this.state.currentStep}
          nextHandler={this.state.isLastStep ? null : this.next}
          backHandler={this.state.level > 0 ? this.back : null}
          deviceId={this.props.location.query.device}
          isFetching={this.props.isFetching}
        />
        <RelatedContentContainer
          contentId={this.props.params.id}
          contentType="guide"
          deviceId={this.props.location.query.device}
        />
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  guide: selectGuide(state),
  isFetching: selectGuideFetching(state)
})

const mapDispatchToProps = (dispatch) => ({
  fetchGuide: (deviceId, guideId) =>
    dispatch(fetchGuide.request(deviceId, guideId)),
  updateTitle: (title) => dispatch(updateTitle(title)),
  createEvent: (event) => dispatch(createEvent(event))
})

export default connect(mapStateToProps, mapDispatchToProps)(GuideContainer)
